import React, { useState, useEffect } from 'react';
import MainPage from './components/MainPage';
import LoginPage from './components/LoginPage';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import MainPageContent from './components/MainPageContentNew';
import ProductsTab from './components/ProductsTab';
import IntegrationsTab from './components/IntegrationTab';
import StocksTab from './components/StocksTab';
import StatisticTab from './components/StatisticTab';
import RequestsTab from './components/RequestsTab';
import Header from './components/Header';
import { CHECK_USER_REQUEST, getFetchRequest } from './store/requests';
import { makeUrl } from './constant';
import ConfigurationTab from './components/ConfigurationTab';
import BannerTab from './components/BannerTab';
import ProductBaseTab from './components/ProductBaseTab';
import PurchasesTab from './components/PurchasesTab';
import NotificationsTab from './components/NotificationsTab';
import SalesTab from './components/SalesTab';
import LogsTab from './components/LogsTab';
import SupplierProductStatusesTab from './components/SupplierProductStatusesTab';
import BusinessCalendarTab from './components/BusinessCalendarTab';
import AutobaseTab from './components/AutobaseTab';
import SiteInfoTab from './components/SiteInfoTab';


const App = () => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const navigate = useNavigate();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isCheckingAuth, setIsCheckingAuth] = useState(true);

    const succesCallback = () => {
        setIsAuthenticated(true);
        setIsCheckingAuth(false);
    };

    const errorCallback = (e) => {
        console.log(e);
        setIsAuthenticated(false);
        setIsCheckingAuth(false);
        navigate("/login");
    };

    useEffect(()=> {
        getFetchRequest(makeUrl([CHECK_USER_REQUEST]), succesCallback, errorCallback);
    },[]);

    if(isCheckingAuth) {
        return null;
    }

    if(!isAuthenticated) {
        return (
            <Routes>
                <Route exact path="*" element={<LoginPage setIsAuthenticated={setIsAuthenticated}/>} />
            </Routes>
        );
    } else {
        return (
            <>
                <Header setIsCollapsed={setIsCollapsed} isCollapsed={isCollapsed} setIsAuthenticated={setIsAuthenticated}/>
                <main className="main">
                    <MainPage isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
                    <Routes> 
                        <Route exact path="/" element={<Navigate to="/sales/users" replace />} />
                        <Route exact path="/sales/*" element={<SalesTab isCollapsed={isCollapsed} />} />
                        <Route exact path="/users" element={<Navigate to="/sales/users" replace />} />
                        <Route exact path="/products" element={<ProductsTab isCollapsed={isCollapsed}/>} />
                        <Route exact path="/integration" element={<IntegrationsTab isCollapsed={isCollapsed}/>} />
                        <Route exact path="/stock" element={<StocksTab isCollapsed={isCollapsed}/>} />
                        <Route exact path="/statistic" element={<StatisticTab isCollapsed={isCollapsed}/>} />
                        <Route exact path="/requests" element={<RequestsTab isCollapsed={isCollapsed}/>} />
                        <Route exact path="/orders" element={<Navigate to="/sales/orders" replace />} />
                        <Route exact path="/purchases/*" element={<PurchasesTab isCollapsed={isCollapsed} />} />
                        <Route exact path="/notifications" element={<NotificationsTab isCollapsed={isCollapsed}/>} />
                        <Route exact path="/configuration" element={<ConfigurationTab isCollapsed={isCollapsed}/>} />
                        <Route exact path="/business-calendar" element={<BusinessCalendarTab isCollapsed={isCollapsed}/>} />
                        <Route exact path="/banner" element={<BannerTab isCollapsed={isCollapsed}/>} />
                        <Route exact path="/logs" element={<LogsTab isCollapsed={isCollapsed} />} />
                        <Route exact path="/supplier-statuses" element={<SupplierProductStatusesTab isCollapsed={isCollapsed} />} />
                        <Route exact path="/autobase" element={<AutobaseTab isCollapsed={isCollapsed} />} />
                        <Route exact path="/site-info" element={<SiteInfoTab isCollapsed={isCollapsed} />} />
                        {/* VPN tab removed */}
                        <Route exact path="/base" element={<ProductBaseTab isCollapsed={isCollapsed}/>} />
                    </Routes>
                </main>
            </>
        );
    }
};

export default App;
